import 'antd/lib/style/index.less' // antd core styles
import { routerMiddleware } from 'connected-react-router'
import { createBrowserHistory } from 'history'
import React from 'react'
import ReactDOM from 'react-dom'
import ReactGA from 'react-ga'
import { Provider } from 'react-redux'
import { applyMiddleware, compose, createStore } from 'redux'
// import { logger } from 'redux-logger'
import createSagaMiddleware from 'redux-saga'
import thunk from 'redux-thunk'
import './components/kit/vendors/antd/themes/dark.less' // dark theme antd components
import './components/kit/vendors/antd/themes/default.less' // default theme antd components
import './global.scss' // app & third-party component styles
import Localization from './localization'
import reducers from './redux/reducers'
import sagas from './redux/sagas'
import Router from './router'

// const trackingId = 'UA-165349069-1'; // Replace with your Google Analytics tracking ID
// ReactGA.initialize(trackingId, {
//   debug: true,
// });
// middlewared
const history = createBrowserHistory()
const sagaMiddleware = createSagaMiddleware()
const routeMiddleware = routerMiddleware(history)
const middlewares = [sagaMiddleware, routeMiddleware, thunk]

function onChange(value) {
  console.log('Captcha value:', value)
}

// if (process.env.NODE_ENV === 'development') {
//   middlewares.push(logger)
// }

const store = createStore(reducers(history), compose(applyMiddleware(...middlewares)))

sagaMiddleware.run(sagas)

history.listen(location => {
  console.log(location, 'location')
  ReactGA.set({ page: location.pathname }) // Update the user's current page
  ReactGA.pageview(location.pathname) // Record a pageview for the given page
})

ReactDOM.render(
  <Provider store={store}>
    <Localization>
      <Router history={history} />
    </Localization>
  </Provider>,
  document.getElementById('root'),
)

export { store, history }
